import * as React from "react";
import { PropsWithChildren } from "react";

import NavbarLinks from "../navbarLinks/NavbarLinks";

type Props = PropsWithChildren<{
  sidebar: boolean;
  toggle: () => void;
  closeSidebar: () => void;
}>;

const Sidebar: React.FC<Props> = (props: Props) => {
  return (
    <div className={`m-sidebar ${props.sidebar ? "m-sidebar--active" : ""}`}>
      <NavbarLinks toggle={props.toggle} closeSidebar={props.closeSidebar} />
    </div>
  );
};

export default Sidebar;
